import type { LookupModel } from '../app/types/lookup.type.ts';
import baseApi from './meeting-md-api-slice';

const dietaryApiSlice = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchDietaryPreferences: builder.query<LookupModel[], void>({
      query() {
        return `/Dietary/Preferences`;
      },
    }),
    fetchDietaryRestrictions: builder.query<LookupModel[], void>({
      query() {
        return `/Dietary/Restrictions`;
      },
    }),
  }),
});

export const { useFetchDietaryPreferencesQuery, useFetchDietaryRestrictionsQuery } =
  dietaryApiSlice;
